import React, { useEffect, useState } from 'react';
import { updateLocalAchievements } from '../features/gamification/events';
import { ACHIEVEMENTS_STATE } from '../core/constants';
import { getDomainCfg, store } from '../core/state';
import { translate } from '../core/i18n';
import { AchievementCard } from '../components/AchievementCard';
import { RoundButton } from '../components/buttons/base/RoundButton';
import { getRedirectUrl, redirectTo } from '../features/redirect';
import { serverFeatureAvailable } from '../features/cloudstorage/cloud';
import { checkUser } from '../features/cloudstorage/user';

export const AchievementView = () => {  
  const [achievementState] = store.useState(ACHIEVEMENTS_STATE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAchievements() {
      console.log("fetchAchievements");
      
      if (serverFeatureAvailable()) {
        try {
          await checkUser(false);
        } catch (e) {
          console.error("AchievementView: Error while checking user", e);
        }
      }
      await updateLocalAchievements(true);
      setLoading(false);
    }
    fetchAchievements();    
  }, []);

  const exitRequested = () => {
    redirectTo(getRedirectUrl(getDomainCfg().viewSettings.projectsView));
  }

  const exitButton = <RoundButton title={translate('exit-btn-title')} onClick={exitRequested} icon="right-to-bracket" iconColor="#ffffff" borderColor='#2243ba' backgroundColor='#305eff' />

  console.log("achievements", achievementState);
  // Erzeugen der Achievement-Karten (ähnlich wie bei den Projektkarten)
  const renderedAchievements = achievementState?.data?.achievements?.map((achievement, index) => {
    // Hier nehmen wir an, dass Sie eine AchievementCard-Komponente haben. Wenn nicht, können Sie eine erstellen.
    return <AchievementCard achievement={achievement} key={achievement.id} />    
  });

  // Container für Achievements
  const achievementContainer = (
    <div className="row" id="achievementcontainer">
      <div className="text-end">{exitButton}</div>
      <div className="col-12">
        <div className="rounded-lg shadow p-3 mb-5 bg-white border bordersize-15 p-5 scrollable-list">
          <div className="row row-cols-1" id="achievements">
            { renderedAchievements }
            { !achievementState.data && <p>{ translate("view-achievements-error-text") }</p>}
          </div>
        </div>
      </div>
    </div>
  );

  const loadingList = (<div className="row" id="loading">
    <div className="col-12 text-center">
      <div className="spinner-grow text-warning" role="status">
        
      </div>
      <p>{ translate("view-achievements-loading-text") }</p>
    </div>
  </div>);

  return (
    <>      
      <div className="container text-center">
        <div className="row">
          <div className="col">
            <p className="h3"><img src={ getDomainCfg().product.logoUrl } className="imgcenter productLogo" width="281" height="57" alt={ getDomainCfg().product.name } /></p>
            <p className="text-center">{ translate("view-achievements-header", getDomainCfg().product.name)}</p>
          </div>
        </div>
        {/* Hier können Sie zusätzliche Menüs oder Buttons hinzufügen, wenn Sie welche haben */}
        <div className="row row-cols-1 text-end mb-10">
          { /* menu */ }
        </div>
        { loading && loadingList }
        { !loading && achievementContainer }
      </div>
    </>
  );
}
